import { render, staticRenderFns } from "./ware.vue?vue&type=template&id=6a776f72&scoped=true&"
import script from "./ware.vue?vue&type=script&lang=js&"
export * from "./ware.vue?vue&type=script&lang=js&"
import style0 from "./ware.vue?vue&type=style&index=0&id=6a776f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a776f72",
  null
  
)

export default component.exports